(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionDialogController', SSFuncionDialogController);

    SSFuncionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSFuncion'];

    function SSFuncionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSFuncion) {
        var vm = this;

        vm.sSFuncion = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSFuncion.id !== null) {
                SSFuncion.update(vm.sSFuncion, onSaveSuccess, onSaveError);
            } else {
                SSFuncion.save(vm.sSFuncion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSFuncionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
